import { useEffect, useState } from "react";
import { api, fmtDate, formatErr } from "../lib/api";
import { Page } from "../components/AppShell";
import { Buildings, Handshake } from "@phosphor-icons/react";

export default function MyHosts() {
  const [hosts, setHosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get("/contractor/my-hosts")
      .then((r) => setHosts(r.data || []))
      .catch((e) => setErr(formatErr(e)))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Page
      title="My Hosts"
      subtitle="HOST ORGS THAT SEND YOU WORK"
      breadcrumbs={[{ label: "Dashboard", to: "/" }, "My Hosts"]}
      testid="my-hosts-page"
    >
      <div className="max-w-5xl mx-auto">
      {err && <div className="text-xs text-destructive mb-3" data-testid="my-hosts-error">{err}</div>}

      {loading ? (
        <div className="p-8 text-center text-muted-foreground" data-testid="my-hosts-loading">Loading…</div>
      ) : hosts.length === 0 ? (
        <div className="surface p-12 text-center text-muted-foreground" data-testid="my-hosts-empty">
          <Handshake size={28} weight="thin" className="mx-auto mb-2" />
          You don&apos;t have any active host orgs yet. Once a host adds you as a contractor partner you&apos;ll see them here.
        </div>
      ) : (
        <div className="surface">
          <table className="dense">
            <thead><tr><th>HOST ORG</th><th>STATUS</th><th>PARTNERED SINCE</th></tr></thead>
            <tbody>
              {hosts.map((h) => (
                <tr key={h.id} data-testid={`my-host-row-${h.id}`}>
                  <td className="flex items-center gap-2">
                    {h.logo_url
                      ? <img src={h.logo_url} alt="" className="w-5 h-5 rounded object-contain" />
                      : <Buildings size={14} weight="thin" />}
                    <span>{h.name}</span>
                  </td>
                  <td className="text-xs uppercase mono">{h.status}</td>
                  <td className="text-xs text-muted-foreground mono">{fmtDate(h.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      </div>
    </Page>
  );
}
